<template>
  <ul
    class="features-grid"
    :class="{
      'features-grid--stagger-in': staggerTransition,
      'features-grid--compact': compact,
    }"
  >
    <li
      v-for="(feature, index) in features"
      :key="feature.id"
      class="features-grid__item"
      :style="staggerStyle(index)"
    >
      <LandingFeatureCard :feature="feature" :tone="tone" :compact="compact" />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import type { LandingFeature, LandingCatalogVisualTone } from '@/types/landingCatalog.types'
import LandingFeatureCard from './LandingFeatureCard.vue'

export default defineComponent({
  name: 'LandingFeatureGrid',

  components: {
    LandingFeatureCard,
  },

  props: {
    features: {
      type: Array as PropType<LandingFeature[]>,
      required: true,
    },
    staggerTransition: {
      type: Boolean,
      default: false,
    },
    tone: {
      type: String as PropType<LandingCatalogVisualTone | 'default'>,
      default: 'default',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    staggerStyle(index: number) {
      if (!this.staggerTransition) return undefined
      return { animationDelay: `${index * 95}ms` }
    },
  },
})
</script>

<style scoped>
.features-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
}

.features-grid__item {
  list-style: none;
}

.features-grid--compact {
  grid-template-columns: 1fr;
  gap: 0.6rem;
}

.features-grid--stagger-in .features-grid__item {
  animation: domain-feature-in 0.45s cubic-bezier(0.22, 1, 0.36, 1) backwards;
}

@keyframes domain-feature-in {
  from {
    opacity: 0;
    transform: translateY(18px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .features-grid--stagger-in .features-grid__item {
    animation: none;
  }
}
</style>
